import { BaseIcon, BaseIconProps } from './BaseIcon';

export const EyeGradient: React.FC<BaseIconProps> = (props) => (
  <BaseIcon gradientId="eyeGrad" {...props}>
    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" stroke="url(#eyeGrad)" />
    <circle cx="12" cy="12" r="3" stroke="url(#eyeGrad)" />
  </BaseIcon>
);
